import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

export class ExportCsvXlsx {
  public static exportToFile<T>(
    fileName: string,
    fileType: 'csv' | 'xlsx' | 'xls',
    data: T[],
    orderedHeader?: string[],
  ) {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data, { header: orderedHeader });
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    let excelBuffer: any;

    if (fileType === 'csv') {
      excelBuffer = XLSX.write(wb, { bookType: 'csv', type: 'array' });
    } else if (fileType === 'xls') {
      excelBuffer = XLSX.write(wb, { bookType: 'xls', type: 'array' });
    } else {
      excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    }

    const blob: Blob = new Blob([excelBuffer], {
      type: 'application/octet-stream'
    });

    FileSaver.saveAs(blob, `${fileName}.${fileType}`);
  }
}